module.exports = __webpack_public_path__ + "static/aumento1-5b11edaf873794eb6e5ad5e660545094.jpg";